<template>

	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Advance Renew</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Enjoy more benefits when you advance renew your TRC Account!
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<inertia-head title="Advance Renew" />

		<div v-if="flash && flash.title" class="alert shadow m-3 border border-default bg-white alert-dismissible" :class="flash.title === 'Status Success' ? 'alert-success' : 'alert-danger'" role="alert">
			<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
			<h3 class="alert-heading fs-5 fw-bold mb-1">{{ flash.title }}</h3>
			<p class="mb-0">
				{{ flash.message }}
			</p>
		</div>

		<div class="block block-rounded">
			<div class="block-header text-center">
				<h3 class="block-title">CURRENT MEMBERSHIP</h3>
			</div>
			<div class="block-content bg-info-light text-center">
				<div class="h3 fw-bold mb-0">
					{{ member.current_rank }} {{ member.add_alias }}
				</div>
				<div v-if="!is_lifetime" class="fs-sm fw-semibold mb-3">
					Expiry: {{ member.expiry }}
				</div>
				<div class="fs-sm fw-semibold mb-3">
					{{member.membership_type}}
				</div>
			</div>
			<div v-if="!is_lifetime" class="block-content block-content-full block-content-sm">
				<div v-if="subscriptions.products.length<=0" class="block-content block-content-full block-content-sm">
					<h3 class="text-center my-5">We could not found an active subscription</h3>
				</div>
				<form v-else @submit.prevent="advanceRenew">
					<div class="row">
						<div class="col-md-6 mb-4">
							<h6 class="fw-semibold">
								Membership
							</h6>
							<div v-if="form.errors.subscription" class="alert alert-danger">
								<p class="fw-semibold mb-0">{{ form.errors.subscription }}</p>
							</div>
							<div class="row">
								<div
									class="col-12"
									v-for="subscription in subscriptions.products"
									:key="subscription.prod_id"
								>
									<div class="form-check form-block mb-3">
										<input
											v-model="form.subscription"
											class="form-check-input"
											type="radio"
											:value="subscription.prod_id"
											:id="subscription.prod_id"
											name="subscription"
										/>
										<label class="form-check-label" :for="subscription.prod_id">
											<span class="d-flex align-items-center">
												<h6 class="fs-sm mb-0">
													{{ subscription.membership }}
												</h6>
												<span
													v-if="subscription.add_display"
													class="badge bg-warning ms-1"
												>
													{{ subscription.add_display }}
												</span>
											</span>
											<small>
												<s v-if="subscription.is_promo==1" class="me-1">&#8369;{{ subscription.regular_amount }}</s>
												<span :class="{'fw-bold text-danger':subscription.is_promo==1}">&#8369;{{ subscription.amount }}</span>
												<div v-if="subscription.add_desc!=null">
													<div v-html="subscription.add_desc"></div>
												</div>
											</small>
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-6 mb-4">
							<h6 class="fw-semibold">Choose Payment Method</h6>
							<div class="row">
								<div class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											value="CARD"
											id="card"
											name="payment_method"
										/>
										<label class="form-check-label" for="card">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/stripe-logo.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY'"
											id="dragonpay"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/dragonpay.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
								<div v-if="payment_available==true" class="col-6">
									<div class="form-check form-block mb-4">
										<input
											v-model="form.payment_method"
											class="form-check-input"
											type="radio"
											:value="'DRAGONPAY-GCASH'"
											id="dragonpay_gcash"
											name="payment_method"
										/>
										<label class="form-check-label" for="dragonpay_gcash">
											<span
												class="d-flex align-items-center"
												style="
													background-image: url(/media/logo/gcash.png);
													background-size: contain;
													background-repeat: no-repeat;
													background-position: center;
													height: 80px;
												"
											>
											</span>
										</label>
									</div>
								</div>
							</div>
							<div v-if="form.payment_method == 'CARD'">
								<div v-if="member.has_card">
									<div class="form-check form-switch mb-4">
										<input
											v-model="form.use_existing_card"
											class="form-check-input"
											type="checkbox"
											:value="true"
											id="example-switch-default1"
											name="example-switch-default1"
										/>
										<label class="form-check-label" for="example-switch-default1">
											Use existing card
										</label>
									</div>
									<div v-if="form.use_existing_card" class="mb-4">
										<p class="mb-0">
											<span class="fw-semibold">CARD:</span>
											<i>**** **** **** {{ member.card.last4 }}</i>
											<span class="badge bg-primary ms-2">{{ member.card.brand }}</span>
											<span>
												<button @click="deleteCCDetails" type="button" class="btn btn-sm btn-outline-danger ms-1" title="Delete My Credit Card Details"><i class="fa fa-trash"></i></button>
											</span>
										</p>
									</div>
								</div>
								<div v-if="!form.use_existing_card" class="form-group mb-4">
									<stripe @accept-token="acceptToken" ref="stripe" />
									<div v-if="form.errors.card" class="invalid-feedback d-block">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.card }}
									</div>
								</div>
							</div>
							<div class="mb-4 text-end space-x-1">
								<button
									class="btn btn-alt-primary"
									:disabled="
										form.processing ||
										!form.subscription ||
										(form.payment_method === 'CARD' &&
											!form.use_existing_card &&
											!form.token)
									"
								>
									
									<span v-if="!form.processing">Pay Now!</span>
									<span v-else>
										<div class="spinner-border spinner-border-sm text-dark" role="status" >
											<span class="sr-only mr-1">Please wait...</span>
										</div>
										<span class="mx-2">Please wait...</span>
									</span>
								</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>


		<modal ref="deleteCreditCardModal">
			<template #title>Delete Credit Card Details</template>
			<template #body>
				<p class="text-danger fw-bold">Are you sure you want to delete your card details?</p>
				<p class="text-danger fw-bold">Your membership will not auto-renew and you might lose some of your benefits.</p>
			</template>
			<template #footer>
				<button @click="confirmDeleteCC" type="button" class="btn btn-alt-danger"
					:disabled="
						form.processing ||
						!form.subscription ||
						(form.payment_method === 'CARD' &&
							!form.use_existing_card &&
							!form.token)
					"
				>
					<div
						v-if="formCC.processing"
						class="spinner-border spinner-border-sm text-dark me-1"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<i v-else class="fa fa-trash me-1"></i>
					<span>YES</span>
				</button>
				<button @click="deleteCreditCardModal.toggleModal" type="button" class="btn btn-alt-secondary">
					<i class="fa fa-times me-1"></i>NO
				</button>
			</template>
		</modal>

	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../Layouts/AuthLayout'
import Stripe from '../../Shared/Components/Stripe'
import { watch, ref } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createToaster } from '@meforma/vue-toaster'

export default {
	layout: AuthLayout,
	props: {
		test: String,
		member: Object,
		is_lifetime: Boolean,
		subscriptions: Object,
		flash: Object,
		flash1: Object,
	},
	components: {
		Stripe,
	},
	setup(props) {
		const toast = createToaster();

		const payment_available = ref(true);

		const deleteCreditCardModal = ref(null);

		const form = useForm({
						subscription: null,
						payment_method: 'CARD',
						token: null,
						use_existing_card: props.member.has_card?true:false,
						action: 'renew',
						rebates: props.subscriptions.rebates,
						test 	: props.test
					})

		if(props.subscriptions.products.length==1)
		{
			if(props.subscriptions.products[0].prod_id.includes("1M"))
			{
				form.payment_method 	= 'CARD';
				payment_available.value = false;
			}
		}

		const formCC = useForm({

		})

		const deleteCCDetails = ()=>{
			deleteCreditCardModal.value.toggleModal();
		}

		const acceptToken = (token) => {
								form.token = token
							}

		const confirmDeleteCC = ()=>{
			formCC.post(route('member.post.cc-details'),{
				preserveScroll: true,
				only:['flash,member,subscriptions'],
				onSuccess: ()=>{
					deleteCreditCardModal.value.toggleModal();
					form.use_existing_card = false;
				}
			})
		}

		const advanceRenew = () => {
						form.post(route('member.advance-renew'), {
							// preserveState: true,
							// preserveScroll: false,
							// only: ['member','flash','flash1'],
							// onSuccess: () => {
							// 	if(props.flash1.result=="success")
							// 	{
							// 		toast.show(props.flash1.message, { type: "success"});
							// 		setTimeout(() => Inertia.visit(route('member.home')), 4000);
							// 	}
							// }
						})
					}


		watch(
			() => form.payment_method,
			(payment_method) => {
				
				if(payment_method=='CARD' && props.member.has_card)
				{
					form.use_existing_card = true;
				}else{
					form.use_existing_card = false;
				}

				if(payment_method!='CARD')
				{
					form.token = null;
				}
			}
		)

		watch(
			() => form.use_existing_card,
			(use_existing_card) => {
				
				if(use_existing_card==true)
				{
					form.token = null;
				}
			}
		)

		watch(()=>form.subscription,(value)=>{
			let val = value.split('+');
			if(value && val[0].includes("1M"))
			{
				form.payment_method = 'CARD';
				payment_available.value = false;
			}else
			{
				payment_available.value = true;
			}
		})

		return {
			deleteCreditCardModal,
			toast,
			form,
			formCC,
			deleteCCDetails,
			confirmDeleteCC,
			advanceRenew,
			payment_available,
			acceptToken,
		}
	},
}
</script>
